import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Price from "../Price/Price";
import firebase from "../Firebase/Firebase";
import Formatter from "../Formatters/Formatters";
import validator from "../Validators/Validators";
import http from "../Http/Http";
import "./FulfillRequest.css";

class FulfillRequest extends Component {
  constructor() {
    super();

    this.state = {
      id: "",
      name: "",
      phoneNumber: "",
      amount: "",
      description: "",
      pin: "",
      errors: {
        pin: false,
        transferFailed: false
      },
      isSubmitTriggered: false,
      isSubmitting: false,
      bank: "",
      isPaid: false
    };

    this.validateForm = this.validateForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.pay = this.pay.bind(this);
  }

  componentDidMount() {
    const id = this.props.match.params.id;
    const signerHandle = localStorage.getItem("signerHandle");

    this.setState({ id, signerHandle });

    firebase
      .database()
      .ref("/requests/" + id)
      .once("value")
      .then(snapshot => {
        const request = snapshot.val();

        this.setState({ ...request });
      });
  }

  handleChange(event) {
    this.setState(
      {
        pin: event.target.value
      },
      () => {
        if (this.state.isSubmitTriggered) {
          this.validateForm();
        }
      }
    );
  }

  validateForm(onValidForm) {
    const errors = {
      pin: !validator.isValidPin(this.state.pin)
    };

    this.setState({ errors });

    const errorKeys = Object.keys(errors).filter(key => errors[key]);

    // invoke callback function when form has no errors
    if (onValidForm && errorKeys.length === 0) {
      onValidForm();
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    this.setState({ isSubmitTriggered: true });
    this.validateForm(this.pay);
  }

  pay() {
    this.setState({ isSubmitting: true });

    const { phoneNumber, signerHandle, amount, description } = this.state;

    http
      .post("/transfer", {
        source: signerHandle,
        target: "$" + phoneNumber,
        symbol: "$tin",
        amount: amount + "",
        labels: {
          type: "SEND",
          description
        }
      })
      .then(() => {
        this.setState({
          isPaid: true,
          isSubmitting: false
        });
      })
      .catch(error => {
        console.log(error);

        const errors = {
          transferFailed: true
        };

        this.setState({
          isSubmitting: false,
          errors
        });
      });
  }

  isSenderReceiverIdentical() {
    const currentUserPhone = localStorage.getItem("phoneNumber");

    return currentUserPhone === this.state.phoneNumber;
  }

  renderForm() {
    const {
      id,
      amount,
      description,
      name,
      phoneNumber,
      bank,
      errors,
      isSubmitting
    } = this.state;

    return (
      <form
        className="fulfill-request-form"
        action=""
        onSubmit={this.handleSubmit}
      >
        <h1 className="fulfill-request-title">Solicitud de dinero</h1>
        <dl className="fulfill-request-details-list">
          <dt className="fulfill-request-details-item-term">Monto</dt>
          <dd className="fulfill-request-details-item-data">
            COP {Formatter.numberToPrice(amount, { showDecimals: false })}
          </dd>
          <dt className="fulfill-request-details-item-term">Transferir a</dt>
          <dd className="fulfill-request-details-item-data">
            <div>{name}</div>
            <div>+{phoneNumber}</div>
          </dd>
          <dt className="fulfill-request-details-item-term">Descripción</dt>
          <dd className="fulfill-request-details-item-data">{description}</dd>
        </dl>
        {this.context.isSignedIn &&
          this.isSenderReceiverIdentical() && (
            <div className="fulfill-request-panel-warning">
              Creaste esta solicitud de pago a ti mismo. No puedes transferir a
              ti mismo.<br />
              <Link to={"/"}>Vuelve a la página de resumen</Link>
            </div>
          )}
        {this.context.isSignedIn &&
          !this.isSenderReceiverIdentical() && (
            <div>
              <p>Ingrese su código pin de 5 dígitos para confirmar</p>
              <div>
                <label className="fulfill-request-label" htmlFor="pin">
                  Código PIN
                </label>
                <input
                  className="fulfill-request-input"
                  id="pin"
                  name="pin"
                  type="password"
                  pattern="[0-9]*"
                  inputMode="numeric"
                  placeholder="00000"
                  value={this.state.pin}
                  onChange={this.handleChange}
                  aria-invalid={this.state.errors.pin}
                  autoComplete="off"
                />
              </div>
              {errors.pin && (
                <div className="fulfill-request-error" aria-live="polite">
                  Ingrese un código de 5 dígitos
                </div>
              )}
              {errors.transferFailed && (
                <div className="fulfill-request-error" aria-live="polite">
                  Error al enviar dinero
                </div>
              )}
              <button
                className="fulfill-request-button button-green"
                onClick={this.handleSubmit}
                disabled={isSubmitting}
              >
                Transferir
              </button>
            </div>
          )}
        {!this.context.isSignedIn && (
          <div>
            <p>
              <Link to={`/ingresar?paymentRequest=${id}`}>Inicie sesión</Link> o
              elija su banco para realizar una transferencia única
            </p>
            <div className="fulfill-request-input-group">
              <label className="fulfill-request-label" htmlFor="bank">
                Banco
              </label>
              <div className="custom-select">
                <select
                  id="bank"
                  name="bank"
                  value={bank}
                  onChange={this.onBankChange}
                >
                  <option disabled value="">
                    Seleccione un banco
                  </option>
                  <option value="2">AV Villas</option>
                  <option value="3">Bancolombia</option>
                  <option value="2">Banco de Bogotá</option>
                  <option value="3">Banco Popular</option>
                  <option value="7">Banco de la República</option>
                  <option value="3">Banco Santander</option>
                  <option value="3">BBVA Colombia</option>
                  <option value="3">Banagrario</option>
                  <option value="3">Bancamía</option>
                  <option value="3">Davivienda</option>
                  <option value="3">Caja Social</option>
                  <option value="3">Colpatria</option>
                  <option value="3">Colmena</option>
                  <option value="3">Citibank Colombia</option>
                  <option value="3">GBN Sudameris</option>
                  <option value="4">Helm</option>
                  <option value="5">HSBC Colombia</option>
                  <option value="8">Procredit</option>
                  <option value="9">RBS</option>
                </select>
              </div>
            </div>
            <Link
              className="fulfill-request-button button-green"
              to={`/pse/banka/${id}`}
            >
              Continuar
            </Link>
          </div>
        )}
      </form>
    );
  }

  renderConfirmation() {
    const { amount, name, phoneNumber, description } = this.state;

    return (
      <div className="fulfill-request-confirmation">
        <div className="fulfill-request-confirmation-intro">
          Tu transferiste
        </div>
        <div className="fulfill-request-confirmation-amount">
          <Price
            valueClassName="fulfill-request-confirmation-amount-value"
            showDecimals={false}
          >
            {parseInt(amount, 10)}
          </Price>
        </div>
        <div className="fulfill-request-confirmation-to">
          <div className="fulfill-request-confirmation-to-label">a</div>
          <div className="fulfill-request-confirmation-to-name">{name}</div>
          <div className="fulfill-request-confirmation-to-phone">
            +{phoneNumber}
          </div>
        </div>
        <div className="fulfill-request-confirmation-description">
          {description}
        </div>
        <Link to="/">volver a la página de resumen</Link>
      </div>
    );
  }

  render() {
    const { isPaid } = this.state;

    return (
      <div className="fulfill-request">
        {!isPaid && this.renderForm()}
        {isPaid && this.renderConfirmation()}
      </div>
    );
  }
}

FulfillRequest.contextTypes = {
  isSignedIn: PropTypes.bool
};

export default FulfillRequest;



// WEBPACK FOOTER //
// ./src/FulfillRequest/FulfillRequest.js